import React from 'react';
import { modalStyles as styles } from './modalStyles';
import { colors } from '../theme';
import { formatDDMMYYYY } from '../utils/dates';

export default function CustomerRmaModalClosedCase({ rma, onClose }) {
  const postDecline = rma?.postDecline && typeof rma.postDecline === 'object' ? rma.postDecline : {};
  const declinedAt = postDecline.decidedAt ? formatDDMMYYYY(postDecline.decidedAt) : null;
  const isRetained = postDecline.choice === 'retain_and_close';

  return (
    <div style={styles.overlay}>
      <div style={{ ...styles.modal, maxWidth: '480px' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
          <div style={{
            width: '40px', height: '40px', borderRadius: '50%',
            backgroundColor: 'rgba(251,146,60,0.12)', border: '1px solid rgba(251,146,60,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '1.1rem', flexShrink: 0
          }}>
            ⚠
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.15rem', color: colors.textStrong }}>Case Closed</h2>
            <div style={{ fontSize: '0.82rem', color: colors.textMuted, marginTop: '0.1rem' }}>
              {rma.rmaId || rma._id}
            </div>
          </div>
        </div>

        {/* Notice card */}
        <div style={{
          borderRadius: '12px', border: '1px solid rgba(251,146,60,0.3)',
          backgroundColor: 'rgba(251,146,60,0.07)', padding: '1rem 1.1rem',
          marginBottom: '1.25rem'
        }}>
          <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#fb923c', marginBottom: '0.5rem' }}>
            Unit transferred to North Invent
          </div>
          <p style={{ margin: 0, fontSize: '0.88rem', color: colors.textBody, lineHeight: 1.6 }}>
            {isRetained
              ? 'You chose to close this case without a return. This unit is now in North Invent\'s possession and will not be shipped back to you.'
              : 'The repair was declined and this unit has been retained by North Invent. It will not be returned.'}
          </p>
        </div>

        {/* Details */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.55rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
            <span style={{ color: colors.textMuted }}>Serial number</span>
            <span style={{ color: colors.textStrong, fontWeight: 600 }}>{rma.serialNumber}</span>
          </div>
          {declinedAt && (
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
              <span style={{ color: colors.textMuted }}>Decision date</span>
              <span style={{ color: colors.textStrong, fontWeight: 600 }}>{declinedAt}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem' }}>
            <span style={{ color: colors.textMuted }}>Outcome</span>
            <span style={{ color: '#fb923c', fontWeight: 600 }}>Repair declined — unit retained</span>
          </div>
        </div>

        {/* Contact note */}
        <p style={{
          fontSize: '0.82rem', color: colors.textMuted, lineHeight: 1.6,
          borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: '1rem', margin: '0 0 1.25rem'
        }}>
          If you believe this is a mistake or have questions about this decision, please contact North Invent directly and reference your case number.
        </p>

        <button onClick={onClose} style={styles.button}>Close</button>
      </div>
    </div>
  );
}
